
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.707 10.707a1 1 0 00.707.293h.964c.424 0 .782.296 1.089.588.269.255.633.412 1.033.412.4 0 .764-.157 1.033-.412.307-.292.665-.588 1.089-.588h8.756c.424 0 .782.296 1.089.588a1.497 1.497 0 002.23-.184c.167-.22.402-.404.678-.404a.65.65 0 00.241-.046l1.667-.667a1 1 0 00.621-1.053l-.294-2.358A1 1 0 0021.617 6h-.851a1 1 0 01-.497-.132l-3.038-1.736A1 1 0 0016.734 4H11.32a1 1 0 00-.58.186L7.681 6.37a1 1 0 01-.402.17l-4.736.861a1 1 0 00-.75.613l-.55 1.374a1 1 0 00.222 1.078l.241.241zm9.656-5.597l-1.25 1a.5.5 0 00.312.89H12.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-.825a.5.5 0 00-.312.11zM14 5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5zm3 1v-.617a.5.5 0 01.757-.429l1.588.953a.32.32 0 01-.164.593H17.5a.5.5 0 01-.5-.5z","fill":"currentColor"}})])
          )
        }
      }
    